<template>
  <div>
    <Popover
      placement="bottom-end"
      width="420"
      class="d-inline pointer"
      :visible-arrow="true"
      popper-class="popover-list bordered"
      v-model="rejectPopover"
    >
      <div>
        <div class="popover-title">
          {{$t('INDENT_REJECT_EPOD')}}
        </div>
        <p class="text-sm ml-10 mr-10">
          {{$t('INDENT_EPOD_DESCRIPTION')}}
          <br>
          {{$t('INDENT_EPOD_ADD_REASON')}}
        </p>
      </div>
      <div class="popover-body p-0">
        <Form :inline="true" class="form-default">
          <FormItem label="Reason" required class="mb-0 form-default">
            <Input placeholder="Add Reason" class="form-control" v-model="reason"/>
          </FormItem>
          <div class="action-edit-block mt-10">
            <div class="text-right">
              <Button size="mini" type="secondary" @click="closeRejectPopover">{{$t('INDENT_EPOD_CANCEL')}}</Button>
              <Button size="mini" type="primary" :disabled="showReject" @click="rejectEpod">{{$t('INDENT_EPOD_CONFIRM')}}</Button>
            </div>
          </div>
        </Form>
      </div>
      <Button slot="reference" class="actions pointer" size="mini" type="secondary" :disabled="disableRejectButton" @click="openRejectPopover">{{$t('INDENT_GRN_REJECT')}}</Button>
    </Popover>
  </div>
</template>

<script>
export default {
  props: ['orderDetails', 'selectedConsignee'],

  data() {
    return {
      reason: '',
      rejectPopover: false,
      showRejectButton: true,
    };
  },
  async created() {
    if (this.selectedConsignee.epod_rejected && this.selectedConsignee.epod_rejected.reason) {
      this.reason = this.orderDetails.epod_rejected.reason;
    }
  },
  computed: {
    showReject() {
      if (this.reason !== '') {
        return false;
      }
      return true;
    },
    disableRejectButton() {
      if (this.selectedConsignee.epod_rejected && this.selectedConsignee.epod_rejected.reason) {
        return true;
      }
      return false;
    },
  },
  methods: {
    async rejectEpod() {
      this.rejectPopover = false;
      this.showRejectButton = false;
      this.selectedConsignee.is_transporter_updated = false;
      try {
        const orderNo = this.orderDetails.order_number;
        const consigneeId = this.selectedConsignee.gate_id;
        const consigneeLocationId = this.selectedConsignee.location_id;

        const destinations = this.orderDetails && this.orderDetails.destinations;
        const sources = this.orderDetails.sources;
        const sourceGateId = (destinations).map(destination =>
          ((destination.gate_id === this.selectedConsignee.gate_id) ? destination.source_gate_id : undefined)).filter(x => x)[0];
        let depotName = '';
        if (sourceGateId) {
          const sourceIndex = (sources).map((source, index) => ((source.gate_id === sourceGateId) ? index : undefined)).filter(x => x >= 0)[0];
          depotName = (sources[sourceIndex] && sources[sourceIndex].details.name) ? sources[sourceIndex].details.name : '';
        }
        const route = (this.orderDetails.route_location && this.orderDetails.route_location.route) ? this.orderDetails.route_location.route : '';
        const vehicleNumber = (this.orderDetails.vehicle && this.orderDetails.vehicle.number) ? this.orderDetails.vehicle.number : '';
        const transporterName = (this.orderDetails.transporter_name) ? this.orderDetails.transporter_name : '';
        const transporterId = (this.orderDetails.transporter && this.orderDetails.transporter.id) ? this.orderDetails.transporter.id : '';
        const dateTime = new Date();
        const result = await this.$store.dispatch('order/rejectEpod', {
          orderNo,
          consigneeId,
          consigneeLocationId,
          reason: this.reason,
          dateTime,
          depotName,
          route,
          vehicleNumber,
          transporterName,
          transporterId,
        });
        if (result.error) {
          this.$error({ message: this.$getErr('EPOD_REJECT_FAILED') });
        } else if (result) {
          this.$warningMessage({
            header: 'Values Rejected',
            message: 'Shortage/Damage/Carton Damage values for this destination has been rejected and the transporter has been notified.',
          });
        }
        this.$emit('epodRejectReason', this.reason);
        this.$emit('epodRejected');
      } catch (err) {
        this.$error({ message: this.$getErr('EPOD_REJECT_FAILED') });
      }
      this.reason = '';
    },
    openRejectPopover() {
      this.rejectPopover = true;
    },
    closeRejectPopover() {
      this.rejectPopover = false;
    },
  },
};
</script>
